import React, { createContext, useCallback, useContext } from 'react';
import { axiosTimeout } from '../helpers/axiosTimeout';
import api from '../services/api';
import { useAuth } from './Auth';

const ManagerContext = createContext();

const ManagerProvider = ({ children }) => {
  const GetAllTransportType = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/transports`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const { transport_Type_List } = response.data.data;

    return transport_Type_List;
  }, []);

  const GetAllFreightType = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/freights`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const { freight_Type_List } = response.data.data;

    return freight_Type_List;
  }, []);

  const GetAllMaterialType = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/materials/valid`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const materialTypeList = response.data.data;

    return materialTypeList;
  }, []);

  const GetStates = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/states`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const { data } = response.data;

    return data;
  }, []);

  const GetAllPickupStatus = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/pickup/status`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const { data } = response.data;

    return data;
  }, []);

  const GetAllPickupType = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/pickuptype`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const { data } = response.data;

    return data;
  }, []);

  const getPickupManagerParameterization = useCallback(
    async ({ branchId, transportTypeId, pickupTypeId, inputTypeId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/parameterization-exist`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            branchId,
            transportTypeId,
            pickupTypeId,
            inputTypeId
          },
          timeout: axiosTimeout
        }
      );

      const { data } = response.data;

      return data;
    },
    []
  );

  const getPickupManagerParameterizationTransportTypes = useCallback(
    async ({ params }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/parametrization-enabled-modal-types`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params,
          timeout: axiosTimeout
        }
      );

      return response;
    },
    []
  );

  const getPickupManagerBranchValidations = useCallback(
    async ({ branchParameterizationId }) => {
      try {
        const token = localStorage.getItem('@Braspress:token');

        const response = await api.get(
          `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/validations`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            params: { branchParameterizationId },
            timeout: axiosTimeout
          }
        );

        const { data } = response.data;

        return data;
      } catch (error) {
        return error;
      }
    },
    []
  );

  const getPickupManagerBranchSchedules = useCallback(
    async ({ branchParameterizationId }) => {
      try {
        const token = localStorage.getItem('@Braspress:token');

        const response = await api.get(
          `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/schedules`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            params: { branchParameterizationId },
            timeout: axiosTimeout
          }
        );

        const { data } = response.data;

        return data;
      } catch (error) {
        return error;
      }
    },
    []
  );

  const getPickupManagerBranchDocumentation = useCallback(
    async ({ branchParameterizationId }) => {
      try {
        const token = localStorage.getItem('@Braspress:token');

        const response = await api.get(
          `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/documentation`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            params: { branchParameterizationId },
            timeout: axiosTimeout
          }
        );

        const { data } = response.data;

        return data;
      } catch (error) {
        return error;
      }
    },
    []
  );

  const getPickupManagerBranchGeneralConfig = useCallback(
    async ({ branchParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/general-configuration`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            branchParameterizationId
          },
          timeout: axiosTimeout
        }
      );

      const { data } = response.data;

      return data;
    },
    []
  );

  const getPickupManagerBranchGeneralConfigTypes = useCallback(async () => {
    const token = localStorage.getItem('@Braspress:token');

    const response = await api.get(
      `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/general-configuration/types`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        timeout: axiosTimeout
      }
    );

    const { data } = response.data;

    return data;
  }, []);

  const getPickupManagerBranchGeneralConfigAccess = useCallback(
    async ({ branchParameterizationId }) => {
      try {
        const token = localStorage.getItem('@Braspress:token');

        const response = await api.get(
          `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/access`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            },
            params: { branchParameterizationId },
            timeout: axiosTimeout
          }
        );

        const branchAccess = response?.data;

        return branchAccess;
      } catch (error) {
        return error;
      }
    },
    []
  );

  const getPickupManagerMaterialList = useCallback(
    async ({ branchParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/api/v1/material/${branchParameterizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          timeout: axiosTimeout
        }
      );

      return response;
    },
    []
  );

  const getPickupManagerMaterialListEnabled = useCallback(
    async ({ branchParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/api/v1/material/enabled/${branchParameterizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          timeout: axiosTimeout
        }
      );

      return response;
    },
    []
  );

  const getPickupManagerCheckList = useCallback(
    async ({ branchParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      try {
        const response = await api.get(
          `${process.env.REACT_APP_URL_MS_MANAGER}/api/v1/checklist/${branchParameterizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        return response;
      } catch (error) {
        return error;
      }
    },
    []
  );

  const getPickupManagerExtensionReasonList = useCallback(
    async ({ branchParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/extension`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            branchParameterizationId
          },
          timeout: axiosTimeout
        }
      );

      const { data } = response.data;

      return data;
    },
    []
  );

  const getPickupManagerCancelReasonList = useCallback(
    async ({ branchParameterizationId }) => {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/cancel`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            branchParameterizationId
          },
          timeout: axiosTimeout
        }
      );

      const { data } = response.data;

      return data;
    },
    []
  );

  const getBranchFilters = useCallback(async ({ branchParameterizationId }) => {
    try {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/filters`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: { branchParameterizationId },
          timeout: axiosTimeout
        }
      );

      const filterList = response?.data.data;

      if (filterList) {
        return filterList;
      }

      return [];
    } catch (error) {
      return error;
    }
  }, []);

  const getIncompatibleGoodsConfiguration = useCallback(
    async ({ branchParameterizationId }) => {
      try {
        const token = localStorage.getItem('@Braspress:token');

        const response = await api.get(
          `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/incompatible-goods/configuration`,
          {
            params: { branchParameterizationId },
            headers: {
              Authorization: `Bearer ${token}`
            },
            timeout: axiosTimeout
          }
        );

        const goodsList = response?.data.data;
        if (goodsList) {
          return goodsList;
        }

        return [];
      } catch (error) {
        return error;
      }
    },
    []
  );

  const getIncompatibleGoods = useCallback(async () => {
    try {
      const token = localStorage.getItem('@Braspress:token');

      const response = await api.get(
        `${process.env.REACT_APP_URL_MS_MANAGER}/manager/branch/incompatible-goods`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          },
          timeout: axiosTimeout
        }
      );

      const goodsList = response?.data.data;
      if (goodsList) {
        return goodsList;
      }

      return [];
    } catch (error) {
      return error;
    }
  }, []);

  const contextValues = {
    GetAllTransportType,
    GetAllFreightType,
    GetAllMaterialType,
    GetStates,
    GetAllPickupStatus,
    GetAllPickupType,
    getPickupManagerParameterization,
    getPickupManagerParameterizationTransportTypes,
    getPickupManagerBranchValidations,
    getPickupManagerBranchSchedules,
    getPickupManagerBranchDocumentation,
    getPickupManagerBranchGeneralConfig,
    getPickupManagerBranchGeneralConfigTypes,
    getPickupManagerBranchGeneralConfigAccess,
    getPickupManagerMaterialList,
    getPickupManagerMaterialListEnabled,
    getPickupManagerCheckList,
    getPickupManagerExtensionReasonList,
    getPickupManagerCancelReasonList,
    getBranchFilters,
    getIncompatibleGoodsConfiguration,
    getIncompatibleGoods
  };

  return (
    <ManagerContext.Provider value={contextValues}>
      {children}
    </ManagerContext.Provider>
  );
};

function useManager() {
  const context = useContext(ManagerContext);

  if (!context) {
    throw new Error('useManager must be used within an ManagerProvider');
  }

  return context;
}

export { ManagerProvider, useManager };
